module.exports = __webpack_public_path__ + "static/img/icon01.5d27c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/index/icon01.png
// module id = Gd7v
// module chunks = 1